const REACT_SCAN_STORAGE_KEY = 'reactscan';

export default async function initializeReactScan() {
  const found = localStorage.getItem(REACT_SCAN_STORAGE_KEY);
  if (found == undefined) {
    localStorage.setItem(REACT_SCAN_STORAGE_KEY, 'false');
  }
  const enabled = localStorage.getItem(REACT_SCAN_STORAGE_KEY) === 'true';
  const reactScan = await import('react-scan');
  reactScan.scan({
    enabled,
    dangerouslyForceRunInProduction: enabled,
  });
}
